export type AdminUser = {
  id: string;
  username: string;
  displayName: string;
  forcePasswordChange: boolean;
  permissions: string[];
  isSuper: boolean;
};
const prefix = '/api/admin/v1';

function errorMessage(error: unknown) {
  if (typeof error === 'string') return error;
  if (!error || typeof error !== 'object') return String(error);
  if ('message' in error) {
    const message = (error as { message: unknown }).message;
    if (typeof message === 'string') return message;
    if (Array.isArray(message)) return message.map(String).join('；');
    if (message && typeof message === 'object') {
      const flattened = message as {
        fieldErrors?: Record<string, string[]>;
        formErrors?: string[];
      };
      const fields = Object.entries(flattened.fieldErrors ?? {}).flatMap(([field, values]) =>
        values.map((value) => `${field}：${value}`),
      );
      return [...(flattened.formErrors ?? []), ...fields].join('；') || '填写内容未通过校验';
    }
  }
  return '请求失败，请稍后重试';
}

export async function api<T>(path: string, init: RequestInit = {}) {
  const headers = new Headers(init.headers);
  if (init.body && !headers.has('Content-Type') && !(init.body instanceof FormData))
    headers.set('Content-Type', 'application/json');
  const csrf = localStorage.getItem('luobo-csrf');
  if (csrf) headers.set('X-CSRF-Token', csrf);
  const response = await fetch(`${prefix}${path}`, { ...init, headers, credentials: 'include' });
  if (!response.ok) {
    let error: unknown;
    try {
      error = await response.json();
    } catch {
      error = await response.text();
    }
    throw new Error(errorMessage(error));
  }
  if (response.status === 204) return undefined as T;
  return response.json() as Promise<T>;
}
export const json = (method: string, body: unknown): RequestInit => ({
  method,
  body: JSON.stringify(body),
});
export async function download(path: string, filename: string) {
  const headers = new Headers();
  const csrf = localStorage.getItem('luobo-csrf');
  if (csrf) headers.set('X-CSRF-Token', csrf);
  const response = await fetch(`${prefix}${path}`, { credentials: 'include', headers });
  if (!response.ok) throw new Error('导出失败');
  const url = URL.createObjectURL(await response.blob());
  const anchor = document.createElement('a');
  anchor.href = url;
  anchor.download = filename;
  anchor.click();
  URL.revokeObjectURL(url);
}
